import { render, staticRenderFns } from "./timelineEventsConfig.vue?vue&type=template&id=19d1dd84&scoped=true"
import script from "./timelineEventsConfig.vue?vue&type=script&lang=js"
export * from "./timelineEventsConfig.vue?vue&type=script&lang=js"
import style0 from "./timelineEventsConfig.vue?vue&type=style&index=0&id=19d1dd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d1dd84",
  null
  
)

export default component.exports